import React from 'react';
import List from './List';
import Image from './Image';
import Avatar from './Avatar';
import ABSField from '../ABSField';
import File, { FileType } from './File';
import classNames from 'classnames';
import { IABSUploadProps, IFileCodeList } from './interface';
import { defaultResult, validatorWithMsg } from '../../utils/Validator';
import { UploadFileType } from './utils';
import commonUtils from '../../utils/commonUtils';
import './index.less';
class ABSUpload extends React.Component<IABSUploadProps, any> {
  state = {
    result: defaultResult
  };

  private uploadRef;

  renderContent() {
    const { type, ...rest } = this.props;
    const { result } = this.state;
    let content;
    switch (type) {
      case 'avatar':
        content = <Avatar ref={ref => (this.uploadRef = ref)} onValidator={this.validatorValue} {...rest} />;
        break;
      case 'image':
        content = (
          <Image
            ref={ref => (this.uploadRef = ref)}
            onValidator={this.validatorValue}
            resetResult={() => {
              this.setState({ result: defaultResult });
            }}
            {...rest}
            result={result}
          />
        );
        break;
      case 'list':
        content = <List ref={ref => (this.uploadRef = ref)} {...rest} />;
        break;
      default:
        content = (
        <File 
          ref={ref => (this.uploadRef = ref)} 
          onValidator={this.validatorValue}
          resetResult={() => {
            this.setState({ result: defaultResult });
          }}
          {...rest} 
        />);
    }
    return content;
  }

  render() {
    const {
      type,
      className,
      titleClassName: titleClass,
      isVertical,
      labelWidth,
      contentWidth,
      title,
      required,
      removeMarginBottom,
      removePaddingLeft,
      desc
    } = this.props;
    const { result } = this.state;
    let fileDefaultTitle = '';
    if (!type || type === 'file') {
      fileDefaultTitle = '附件';
    }
    if (title === undefined && !fileDefaultTitle) {
      return this.renderContent();
    }
    const titleClassName = classNames({ 'abs-upload-image-title': type === 'image' }, titleClass);
    return (
      <ABSField
        result={result}
        className={classNames('abs-upload', className)}
        titleClassName={titleClassName}
        title={title || fileDefaultTitle}
        required={required}
        labelWidth={labelWidth}
        contentWidth={contentWidth}
        removePaddingLeft={removePaddingLeft}
        removeMarginBottom={removeMarginBottom}
        desc={desc}
        isVertical={isVertical}
      >
        {this.renderContent()}
      </ABSField>
    );
  }

  validatorValue = data => {
    const { type } = this.props;
    if (type === 'list') {
      return defaultResult;
    }
    const { rules = [], required, title } = this.props;
    if (!rules.length && !required) {
      return defaultResult;
    }
    let newRules = commonUtils.deep(rules);
    if (required) {
      newRules.unshift({
        required,
        message: '请选择' + (title || '内容')
      });
    }
    const val = this.getValue();
    const result = validatorWithMsg(data || val, newRules);
    this.setState({ result });
    return result;
  };

  reset = () => {
    const { type } = this.props;
    if (type === 'list' || !this.uploadRef) {
      return;
    }
    this.setState({ result: defaultResult });
    this.uploadRef.reset();
  };

  getValue = () => {
    const { type } = this.props;
    if (type === 'list' || !this.uploadRef) {
      return '';
    }
    return this.uploadRef.getValue();
  };

  // 只对上传文件类型可用
  onDelete = (index: number, e?: any) => {
    const { type } = this.props;
    if (type === 'avatar' || type === 'list' || type === 'image' || !this.uploadRef) {
      return;
    }
    this.uploadRef.onDelete(index, e);
  };

  // 只对上传表格（List、image）类型可用
  onRefresh = () => {
    const { type } = this.props;
    if (type === 'avatar' || type === 'file' || !this.uploadRef) {
      return;
    }
    this.uploadRef.onRefresh();
  };
}

export { IABSUploadProps, IFileCodeList };
export { FileType, UploadFileType };
export { File, Avatar, Image, List };

export default ABSUpload;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSUpload/index.tsx